import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between pb-3 h-full mr-2" }
const _hoisted_2 = { class: "grid text-sm font-basier lg:text-base attachments-list" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex-col justify-start" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Opisane ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Połącz dokument")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ze zleceniem")
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Dodaj co najmniej jeden załącznik.", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "flex gap-x-2 items-center mb-2 mt-4"
}
const _hoisted_16 = { class: "flex-col justify-start" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Dodaj załączniki ")
const _hoisted_19 = {
  key: 0,
  class: "text-red absolute"
}

import InvoiceAttachmentsDialog from '@/components/addInvoice/InvoiceAttachmentsDialog.vue'
import { computed, ref } from 'vue'
import {
    UiCardText,
    UiFileUpload,
    UiRemovableFileItem,
    UiButton,
    UiLoadingSpinner,
} from '@/components/common/ui'
import { UploadedFileType } from '@/types/partials'
import { useNotifications } from '@/composables/useNotifications'
import { useApi } from '@/composables/useApi'
import { InvoiceFormModes, useAdviceDocuments } from '@/composables/useAdviceDocuments'
import * as zip from 'tomzipjs'

interface IProps {
    error?: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    error: { type: Boolean, required: false, default: false }
  },
  setup(__props: any) {

const props = __props as { error: boolean }
const { pushSuccess, pushFail } = useNotifications()



const fileLoading = ref(false)

const { usePost } = useApi()

const {
    addAttachmentFiles,
    attachmentFiles,
    invoiceFormMode,
    fetchInvoiceData,
    removeAttachmentFile,
    removeAllAttachmentFiles,
    addPaginatedAttachment,
    // attachmentDescriptions,
    // paginatedAttachmentFiles,
    validate,
} = useAdviceDocuments()
fetchInvoiceData()

const attachments = computed(() => {
    return attachmentFiles.value
})

const onFileUpload = async (files: UploadedFileType[]) => {
    if (!files[0].name.endsWith('.pdf')) {
        pushFail('Zły format pliku')
        return
    }
    fileLoading.value = true
    let zipFile
    try {
        zipFile = await usePost(
            '/invoices/split',
            [
                {
                    filename: files[0].name,
                    base64: files[0].base64,
                },
            ],
            {
                responseType: 'blob',
            },
        )

        const zipReader = new zip.ZipReader(new zip.BlobReader(new Blob([zipFile.data])))
        const result = await zipReader.getEntries()

        const paginatedFile = []
        for (const entry of result) {
            const filename = entry.filename
            const img = await entry.getData(new zip.Data64URIWriter('image/png'))
            paginatedFile.push({ filename, img })
        }
        addAttachmentFiles(files)
        addPaginatedAttachment(paginatedFile, files[0].id)
        pushSuccess('Pomyślnie dodano plik')
    } catch (error) {
        pushFail('Nie udało się załadować pliku')
    } finally {
        fileLoading.value = false
    }
}

const onAttachmentRemove = (id: string | number) => {
    removeAttachmentFile(id)
}

const currentAttachment = ref<UploadedFileType | undefined>(undefined)
const attachmentDialogOpen = ref(false)
const setAttachmentDialogOpen = (open: boolean, attachment: UploadedFileType) => {
    attachmentDialogOpen.value = open
    currentAttachment.value = attachment
}

const onInit = () => {
    invoiceFormMode.value === InvoiceFormModes.CORRECTION && removeAllAttachmentFiles()
}

onInit()

return (_ctx: any,_cache: any) => {
  const _component_IconCheck = _resolveComponent("IconCheck")!
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(UiCardText), { title: "Wgrane pliki" }, {
        default: _withCtx(() => [
          (_unref(attachments) && _unref(attachments).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments), (attachment, attachmentIdx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: attachmentIdx,
                    class: "flex gap-x-2 items-center mb-2 border rounded-lg p-4 bg-white border-blue"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(UiRemovableFileItem), {
                        class: "mb-1",
                        name: attachment.name,
                        onClick: ($event: any) => (onAttachmentRemove(attachment.id))
                      }, null, 8, ["name", "onClick"]),
                      _createVNode(_unref(UiButton), {
                        class: "py-2",
                        primary: "",
                        onClick: ($event: any) => (setAttachmentDialogOpen(true, attachment))
                      }, {
                        default: _withCtx(() => [
                          (_unref(validate)(attachment).value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _hoisted_6,
                                _createVNode(_component_IconCheck, { class: "ml-2" })
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_11))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_unref(invoiceFormMode) !== _unref(InvoiceFormModes).CORRECTION)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true),
          (fileLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(UiLoadingSpinner), { text: "Ładowanie" })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_unref(UiFileUpload), {
        id: 'attachments',
        multiple: true,
        "button-props": { primary: true },
        "hide-success": true,
        onFilesUpload: onFileUpload
      }, {
        default: _withCtx(() => [
          _hoisted_18,
          _createVNode(_component_IconCross, { class: "ml-2" })
        ]),
        _: 1
      }),
      (props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Dodaj co najmniej jeden załącznik "))
        : _createCommentVNode("", true)
    ]),
    _createVNode(InvoiceAttachmentsDialog, {
      attachment: currentAttachment.value,
      open: attachmentDialogOpen.value,
      onClose: setAttachmentDialogOpen
    }, null, 8, ["attachment", "open"])
  ]))
}
}

})